export class VisualforceError extends Error {
  constructor(errors) {
    super(`A Visualforce error occurred: ${errors.map(error => error.title).join(',')}`);

    this.name = VisualforceError.name;
    this.errors = errors;
  }
}
